import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const permissionRoute: RouteConfig = {
  name: 'permissions',
  path: ':roleId',
  component: () => import(/* webpackChunkName: "PermissionList" */ '@/views/mainRoute/role/PermissionList.vue'),
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'Uprawnienia',
      name: 'permissions'
    }
  },
  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('role/setId', parseInt(to.params.roleId));

    store
      .dispatch('permission/list', { count: -1 })
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: Errors.PERMISSION_CANNOT_LIST }));
  }
};
